import { redirect, type LoaderFunctionArgs } from 'react-router-dom';

import { deleteBan } from '@/features/player/ban/api/banApi';

export async function action({ params }: LoaderFunctionArgs) {
  const { banId, playerId } = params;
  if (!banId || !playerId) {
    return redirect('404');
  }
  await deleteBan(banId);

  return redirect(`/players/${playerId}/bans`);
}
